(function ($) {
	const $carousels = $('.wp-block-group.is-style-carousel');

	if (!$carousels.length) {
		return;
	}

	$carousels.each(function () {
		const $carousel = $(this);
		$carousel.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			dots: false,
			arrows: true,
			infinite: false,
			autoplaySpeed: 5000,
			appendArrows: $carousel,
			appendDots: $carousel,
			prevArrow:
				'<button class="slick-prev"><span class="sr-only">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" fill="none"><circle cx="20" cy="20.19" r="20" fill="currentColor"/><path fill="#fff" d="M26.791 19.19h-11.17l4.88-4.88c.39-.39.39-1.03 0-1.42a.996.996 0 0 0-1.41 0l-6.59 6.59a.996.996 0 0 0 0 1.41l6.58 6.6a.996.996 0 1 0 1.41-1.41l-4.87-4.89h11.17c.55 0 1-.45 1-1s-.45-1-1-1Z"/></svg></button>',
			nextArrow:
				'<button class="slick-next"><span class="sr-only">next</span><svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" fill="none"><circle cx="20" cy="20.19" r="20" fill="currentColor"/><path fill="#fff" d="M13.209 21.19h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59a.996.996 0 0 0 0-1.41l-6.58-6.6a.996.996 0 1 0-1.41 1.41l4.87 4.89h-11.17c-.55 0-1 .45-1 1s.45 1 1 1Z"/></svg></button>',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});
	});
})(jQuery);
